export const fetchAlertRecords = (alerts) => {
  // Return action
  //console.log("fetchAlertRecords: " + JSON.stringify(alerts));
  return {
    // Unique identifier
    type: 'GET_ALERTS',
	alerts: alerts
  }
};
export const fetchAlertRecord = (oneAlert) => {
  // Return action
  //console.log("fetchAlertRecord: " + JSON.stringify(oneAlert));
  return {
    // Unique identifier
    type: 'GET_ALERT',
	oneAlert: oneAlert
  }
};